/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Pronunciation_LabelInputs */

const en_why_listening_pronunciation_label = /** @type {(inputs: Why_Listening_Pronunciation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scientific pronunciation`)
};

const es_why_listening_pronunciation_label = /** @type {(inputs: Why_Listening_Pronunciation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pronunciación científica`)
};

/**
* | output |
* | --- |
* | "Scientific pronunciation" |
*
* @param {Why_Listening_Pronunciation_LabelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_pronunciation_label = /** @type {((inputs?: Why_Listening_Pronunciation_LabelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Pronunciation_LabelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_pronunciation_label(inputs)
	return en_why_listening_pronunciation_label(inputs)
});